import {
  VIDEO_EMBED_IFRAME_ALLOW,
  type VideoProvider,
  buildEmbedSrc,
} from '@leanin/shared/video-embed';
import styles from './VideoEmbedFrame.module.css';

interface Props {
  readonly provider: VideoProvider;
  readonly url: string;
  /** Used as the iframe `title` for accessibility. */
  readonly title: string;
}

// Privacy-friendly 16:9 video player. Rewrites incoming YouTube / Vimeo URLs
// to their nocookie / player.vimeo equivalents via `buildEmbedSrc`; renders
// nothing if the URL cannot be parsed (caller decides whether to show a
// fallback link).
export function VideoEmbedFrame({ provider, url, title }: Props) {
  const src = buildEmbedSrc(provider, url);
  if (src === null) return null;
  return (
    <div className={styles.wrap}>
      <iframe
        className={styles.frame}
        src={src}
        title={title}
        allow={VIDEO_EMBED_IFRAME_ALLOW}
        allowFullScreen
        loading="lazy"
      />
    </div>
  );
}
